import { useDynamicFiltersStoreBuilder } from "@/shared/stores/dynamic-filters-builder.store";

export const useControlFiltersStore = useDynamicFiltersStoreBuilder();
